import { Container } from 'react-awesome-styled-grid'

import { between } from 'polished'
import styled from 'styled-components'

export const HeaderWrapper = styled.header`
  position: fixed;
  z-index: 2000;
  width: 100%;
  top: 0;
  left: 0;
  padding-top: 10px;
  height: 90px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.light};
`

export const HeaderContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const HeaderMenu = styled.nav`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 90px);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1999;
  visibility: hidden;
  overflow-x: hidden;
  overflow-y: auto;
  opacity: 0;
  transition: all 0.75s ease;
  background-color: ${({ theme }) => theme.colors.primary};
  padding-top: 80px;
  padding-bottom: 80px;

  ${({ opened }) =>
    opened &&
    `
      opacity: 1;
      visibility: visible;
  `}
`

export const HeaderMenuList = styled.ul`
  margin-bottom: auto;
  margin-top: auto;
`

export const HeaderMenuItem = styled.li`
  &:not(:last-of-type) {
    margin-bottom: ${between('18px', '24px')};
  }
`

export const HeaderMenuLink = styled.a`
  color: ${({ theme }) => theme.colors.light} !important;
  font-size: ${between('16px', '24px')};
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`
